var map = {
	"./add-article-dialog": 2255,
	"./add-article-dialog.js": 2255,
	"./article-search-dialog": 11752,
	"./article-search-dialog.js": 11752,
	"./bar-code-scan-dialog": 7519,
	"./bar-code-scan-dialog.js": 7519,
	"./charge-dialog": 19682,
	"./charge-dialog.js": 19682,
	"./comment-dialog": 25413,
	"./comment-dialog.js": 25413,
	"./comment-preview-dialog": 9679,
	"./comment-preview-dialog.js": 9679,
	"./document-search-dialog": 57630,
	"./document-search-dialog.js": 57630,
	"./family-dialog": 58169,
	"./family-dialog.js": 58169,
	"./generate-delivery-form-dialog": 19369,
	"./generate-delivery-form-dialog.js": 19369,
	"./generate-stock-doc-dialog": 16746,
	"./generate-stock-doc-dialog.js": 16746,
	"./in-lots-dialog": 54288,
	"./in-lots-dialog.js": 54288,
	"./in-serials-dialog": 89749,
	"./in-serials-dialog.js": 89749,
	"./inventory-lots-dialog": 85684,
	"./inventory-lots-dialog.js": 85684,
	"./inventory-serials-dialog": 18823,
	"./inventory-serials-dialog.js": 18823,
	"./lots-dialog": 10085,
	"./lots-dialog.js": 10085,
	"./merge-documents-dialog": 56944,
	"./merge-documents-dialog.js": 56944,
	"./out-lots-dialog": 53890,
	"./out-lots-dialog.js": 53890,
	"./out-serials-dialog": 36818,
	"./out-serials-dialog.js": 36818,
	"./price-request-response-dialog": 22480,
	"./price-request-response-dialog.js": 22480,
	"./provider-dialog": 13835,
	"./provider-dialog.js": 13835,
	"./provider-search-dialog": 83569,
	"./provider-search-dialog.js": 83569,
	"./serials-dialog": 55624,
	"./serials-dialog.js": 55624,
	"./tariff-details-dialog": 71708,
	"./tariff-details-dialog.js": 71708,
	"./warehouse-dialog": 9305,
	"./warehouse-dialog.js": 9305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70528;